import { FunctionComponent, useRef, useEffect } from 'react';
import RailzConnect from '@railzai/railz-connect';
import { useClientData } from '../../../../providers/ClientData.provider';
import { RailzService, railzServicesToExclude } from '../railzServices';
import RailzConnectType from './railz-connect';
import styles from './RailzConnect.module.scss';

export type RailzConnectProps = {
  redirectURL: string;
  /** Where the widget's close button lands; must not re-open the widget, or the flow has no exit */
  closeRedirectURL: string;
  /** Restricts the widget to this one service (an ERP card was clicked); omit to let the user pick */
  service?: RailzService;
};
type FC = FunctionComponent<RailzConnectProps>;

const RailzConnectFrame: FC = ({ redirectURL, closeRedirectURL, service }: RailzConnectProps) => {
  const { response } = useClientData();
  const ref = useRef(null);
  const widgetId = import.meta.env.VITE_RAILZ_WIDGET_ID;

  useEffect(() => {
    const widget: RailzConnectType = new (RailzConnect as typeof RailzConnectType)();

    widget.mount({
      parentElement: ref.current,
      widgetId,
      businessName: response.AccountID,
      brandColor: '000000',
      accentColor: 'FFFFFF',
      language: 'en',
      redirectUrl: redirectURL,
      closeRedirectUrl: closeRedirectURL,
      removeRailzWatermark: true,
      closeEnabled: true,
      options: service ? { services: { exclude: railzServicesToExclude(service) } } : undefined,
    });
  }, []);

  return <div className={styles.railzConnectContainer} id="railz-connect" ref={ref} data-service={service} />;
};

export default RailzConnectFrame;
